import createContainers from "./container";
import Tms from "./tms.class";
import { datadogLogs } from '@datadog/browser-logs';
function main() {
  datadogLogs.init({
    clientToken: 'puba9168fd26e93544046938ad835c8d048',
    site: 'datadoghq.eu',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    forwardConsoleLogs: 'all'
  });
  const logger = datadogLogs.createLogger('frontend_tms', {
    level: 'info',
    context: {
      env: 'production',
      version: '1.0.0'
    }
  });
  window.lm.DOMReady(() => {
    window.tmsScriptLoadStart = performance.now();
    const tms = new (Tms(window.lm.Composant))();
    createContainers(tms.target && JSON.parse(tms.target.dataset.containers));
    Object.assign(window.tms, tms.init(window.tms._q));
    window.tmsScriptLoadEnd = performance.now();
    delete window.tms._q;
    const tmsScriptLoadDuration = window.tmsScriptLoadEnd - window.tmsScriptLoadStart;
    logger.info('TMS script loaded', {
      duration_ms: tmsScriptLoadDuration,
      start: window.tmsScriptLoadStart,
      end: window.tmsScriptLoadEnd,
      timestamp: Date.now()
    });
  });
}
if (document.currentScript) {
  main();
}
export default main;